import { METHOD } from './method'

export const API_SALE_PAGE = {
    DETAIL: {
        api: '/v1/dashboard-admin/general-setting/sale',
        method: METHOD.GET,
    },
    VOUCHER_LIST: {
        api: '/v1/dashboard-admin/general-setting/list-voucher',
        method: METHOD.GET,
    },
    PRODUCT_LIST: {
        api: '/v1/dashboard-admin/general-setting/list-product',
        method: METHOD.GET,
    },
    URL_BANNER: {
        api: '/v1/dashboard-admin/general-setting/sale/storage-url/attachment',
        method: METHOD.POST,
    },
    UPDATE: {
        api: '/v1/dashboard-admin/general-setting/sale',
        method: METHOD.PUT,
    },
}
